export enum Icons {
    CALENDAR = "CALENDAR",
    NOTE = "NOTE",
    CIRCLE = "CIRCLE",
    ADD = "ADD",
    LEFT_ARROW = "LEFT_ARROW",
    RIGHT_ARROW = "RIGHT_ARROW",
    EDIT = "EDIT",
    SAVE = "SAVE",
    DELETE = "DELETE",
}
